import { OnInit } from '@angular/core';
import { Directive } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[dirOnlyAllowNumber]'
})
export class OnlyAllowNumberDirective implements OnInit {

  constructor(private control: NgControl) {

  }

  ngOnInit() {
    const c = this.control.control;

    c.valueChanges.subscribe(x => {

      const value = c.value;

      if (!value)
        return;

      const valueNumber = Number(value.toString().replace(/\D/g, ''));

      const valMax = c.validator(c)?.max;

      if (valMax && valMax?.max < valMax.actual) {
        c.setValue(valMax?.max, { emitEvent: false })
        return;
      }

      c.setValue(valueNumber, { emitEvent: false })
    })
  }

}
